<div class="box-parent">
  <table align="center" border="0">
    <tr style="height: 10px"></tr>
    <tr>
      <th style="text-align: right">วันที่ออกเอกสาร:</th>
      <th width="10px"></th>
      <th>
        <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" [maxDate]="maxDate" readonlyInput="true"
                    [showIcon]="true" dateFormat="dd/mm/yy" (onSelect)="setMinDate()"></p-calendar>
      </th>
      <th style="text-align: right">ถึงวันที่:</th>
      <th width="10px"></th>
      <th>
        <p-calendar [(ngModel)]="endDate" [minDate]="minDate" readonlyInput="true" [showIcon]="true"
                    (onSelect)="setMaxDate()" dateFormat="dd/mm/yy" [disabled]="!startDate"></p-calendar>
      </th>
    </tr>
    <tr style="height: 10px"></tr>
    <tr>
      <th style="text-align: right"> ค้นหา:</th>
      <th width="10px"></th>
      <td>
        <input class="general-input" type="text" [(ngModel)]="inputText"
               placeholder="เลขที่เอกสาร, ชื่อผู้ซื้อ, เลขที่ผู้เสียภาษี "
               style="width: 400px">
      </td>
    </tr>
  </table>
  <div class="m-t-10" style="text-align: center">
    <button type="button" class="btn btn-primary" (click)="searchE()" [disabled]="loading" style="width: 200px">
      <i *ngIf="loading" class="fa fa-spinner fa-spin m-r-5"></i>
      ค้นหา
    </button>
    <button type="button" class="btn btn-primary" (click)="clearSearch()">ล้างการค้นหา</button>
  </div>
</div>

<div class="box-parent">
  <table class="table table-striped m-t-30">
    <thead>
    <tr style="color: #ffffff; background-color: #036BB3; text-align: center">
      <th scope="col" style="width: auto">ลำดับ</th>
      <th scope="col" style="width: auto">เดือน</th>
      <th scope="col">จำนวน</th>
      <th scope="col">มูลค่า</th>
      <th scope="col">ภาษี</th>
      <th scope="col">รวม</th>
      <!--<th scope="col">รายงานภาษีขาย</th>-->
      <th scope="col">XML</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let res of list; let index = index" style="text-align: center">
      <td (click)="openModal(res, index)">{{((currentPage - 1) * 10) + index + 1}}</td>
      <td (click)="openModal(res, index)">{{res.month}}-{{res.year}}</td>
      <td (click)="openModal(res, index)">{{res.count.toLocaleString()}}</td>
      <td (click)="openModal(res, index)">{{res.sum_total_items_net_line_exclude_vat.toLocaleString()}}</td>
      <td (click)="openModal(res, index)">{{res.sum_total_items_vat.toLocaleString()}}</td>
      <td (click)="openModal(res, index)">{{res.sum_total_items_total_payment.toLocaleString()}}</td>
      <!--<td>-->
        <!--<button type="button" class="btn btn-success" (click)="download(res, index)" [disabled]="res.pdfLoading">-->
          <!--<i *ngIf="res.pdfLoading" class="fa fa-spinner fa-spin m-r-5"></i>-->
          <!--Download-->
        <!--</button>-->
      <!--</td>-->
      <td>
        <button type="button" class="btn btn-success" (click)="downloadZip2MB(res, index)" [disabled]="res.xmlLoading">
          <i *ngIf="res.xmlLoading" class="fa fa-spinner fa-spin m-r-5"></i>
          XML
        </button>
      </td>
    </tr>
    </tbody>
  </table>
  <div class="pagination m-t-10 col-md-12">
    <ngb-pagination [collectionSize]="totalItems" [(page)]="currentPage" [maxSize]="10"
                    (pageChange)="pageChanged()" aria-label="Default pagination"></ngb-pagination>
  </div>
</div>

<app-saletax-grouped-list-detail #detailModal></app-saletax-grouped-list-detail>



// WEBPACK FOOTER //
// /opt/app/src/app/features/saletax/grouped-list/grouped-list.component.html